module.exports = __webpack_public_path__ + "eb5c28ff2e7828850dc8b68781be7325.svg";